import { render } from "./ComponentePeajes.vue?vue&type=template&id=21080a2c&scoped=true"
import script from "./ComponentePeajes.vue?vue&type=script&lang=js"
export * from "./ComponentePeajes.vue?vue&type=script&lang=js"

import "./ComponentePeajes.vue?vue&type=style&index=0&id=21080a2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21080a2c"]])

export default __exports__